export const BOOKING_URL = "https://calendly.com/robert-thepolemikoiagency/30min";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IMAGES = {
  hero: "https://images.pexels.com/photos/27694184/pexels-photo-27694184.jpeg",
  office: "https://images.unsplash.com/photo-1758520145140-c2dd8e78fc02",
  ai: "https://images.pexels.com/photos/10653941/pexels-photo-10653941.jpeg",
  stairs: "https://images.unsplash.com/photo-1472803828399-39d4ac53c6e5",
};
